import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

function importAllImages() {
    const context = require.context('./images/toyIcons', false, /\.(png|jpe?g|svg)$/);
    const imageMap = {};

    // Extract the id from the filename and use it as the key
    context.keys().forEach((key) => {
        // Extract the filename without extension (e.g., "./1.png" → "1")
        const id = key.replace(/^\.\//, '').replace(/\.(png|jpe?g|svg)$/, '');
        imageMap[id] = context(key);
    });

    return imageMap;
}

// --- Sortable Item Component ---
export function SortableItem({ id, isDragging }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging: isItemActuallyDragging // Renamed to avoid conflict if passed down
    } = useSortable({ id });

    const itemSize = 65; // Adjust this value to your desired square size
    const style = {
        transform: CSS.Transform.toString(transform),
        transition: isItemActuallyDragging ? undefined : transition,
        width: `${itemSize}px`,
        height: `${itemSize}px`,
        border: '1px solid grey',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '8px', // Adjust spacing as needed
        backgroundColor: isItemActuallyDragging ? 'lightblue' : 'black',
        opacity: isItemActuallyDragging ? 0.5 : 1,
        cursor: 'grab',
        boxShadow: isItemActuallyDragging ? '0 2px 10px rgba(0,0,0,0.2)' : 'none',
        touchAction: 'none',// Recommended by dnd-kit docs for sortable items
        outline: '3px solid #616161',
        overflow: 'hidden', // In case images are too large
        borderRadius: '15px',
    };

    const imageMap = importAllImages();
    function getImageById(id) {
        return imageMap[id] || null; // Return null if no image found for this ID
    }

    return (
        <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
            {/*Item {id}*/}
            <img
                src={getImageById(id)}
                alt={`Item ${id}`}
                style={{
                    maxWidth: '100%',
                    maxHeight: '100%',
                    objectFit: 'contain'
                }}
            />
        </div>
    );
}